import { useTranslation } from "react-i18next"

import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

import { Campaign } from "../campaigns-types"
import { useMutationCloseCampaign } from "./campaign-queries"
import { DialogMutation } from "./dialog-mutation"

type DialogProps = {
  campaign: Campaign
  close: (value: boolean) => void
}

export function DialogCloseCampaign({ campaign, close }: DialogProps) {
  const { t } = useTranslation()

  const mutation = useMutationCloseCampaign()

  async function handleClose(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    await mutation.mutateAsync(campaign.campaign_id)
  }

  return (
    <DialogContent isPending={mutation.isPending}>
      <form onSubmit={handleClose}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {t("campaigns.dialogs.close.title")}
          </DialogTitle>
        </DialogHeader>

        <DialogMutation
          status={mutation.status}
          action={
            <Button
              type="submit"
              variant="destructive"
              isLoading={mutation.isPending}
            >
              {t("campaigns.actions.close")}
            </Button>
          }
          successMessage={t("campaigns.dialogs.close.success")}
          errorMessage={t("campaigns.dialogs.error")}
          close={close}
        >
          <div className="flex flex-col gap-4">
            <p>{t("campaigns.dialogs.close.description")}</p>

            <p>{t("campaigns.dialogs.close.callHistoryNote")}</p>

            <Alert>
              <AlertDescription>
                {t("campaigns.dialogs.close.limitNote")}
              </AlertDescription>
            </Alert>

            <p>
              <code
                className="
                  relative rounded-sm bg-muted px-[0.3rem] py-[0.2rem] font-mono
                  text-sm font-semibold
                "
              >
                {campaign.campaign_id}
              </code>
            </p>

            <p className="font-medium">
              {t("campaigns.dialogs.close.confirm")}
            </p>
          </div>
        </DialogMutation>
      </form>
    </DialogContent>
  )
}
